import React from "react";
import { useFormComponentConfig } from "@/hooks/useFormComponentConfig";
import type { Component } from "@/types/FormConfig";

export function withConfig<P extends { config: unknown }>(
  WrappedComponent: React.ComponentType<P>,
  componentName: Component["name"],
): React.FC<Omit<P, "config">> {
  const ComponentWithConfig: React.FC<Omit<P, "config">> = (props) => {
    const formComponent = useFormComponentConfig(componentName);

    if (!formComponent) {
      throw new Error(`${componentName} config not found`);
    }

    return <WrappedComponent {...(props as P)} config={formComponent.config} />;
  };

  ComponentWithConfig.displayName = `withConfig(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;

  return ComponentWithConfig;
}
